import { useState, useRef } from "react";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export default function CargaStock() {
  const [archivo,  setArchivo]  = useState(null);
  const [fecha,    setFecha]    = useState(new Date().toISOString().slice(0, 10));
  const [estado,   setEstado]   = useState("idle"); // idle | cargando | exito | error
  const [mensaje,  setMensaje]  = useState("");
  const ref = useRef();

  const handleEnviar = async () => {
    if (!archivo) return;
    setEstado("cargando");
    setMensaje("");
    const formData = new FormData();
    formData.append("archivo", archivo);
    formData.append("fecha", fecha);
    try {
      const res = await fetch(`${API_URL}/api/stock`, {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        body: formData,
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || `Error ${res.status}`);
      }
      const data = await res.json();
      setEstado("exito");
      setMensaje(`Cargados ${data.productos} productos para el ${fecha}.`);
      setArchivo(null);
      if (ref.current) ref.current.value = "";
    } catch (e) {
      setEstado("error");
      setMensaje(e.message || "Error al cargar el archivo de stock.");
    }
  };

  return (
    <div style={{ maxWidth: 560, margin: "0 auto", padding: "2rem 0" }}>
      <div style={{ marginBottom: "1.5rem" }}>
        <h2 style={{ fontSize: 16, fontWeight: 500, margin: "0 0 6px 0" }}>Snapshot de stock</h2>
        <p style={{ fontSize: 13, color: "#888", margin: 0 }}>
          Sube el archivo de stock del proveedor con la fecha de carga. Cada carga registra un nuevo punto en la evolución histórica.
        </p>
      </div>

      {/* Selector de fecha */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: "0.85rem" }}>
        <label style={{ fontSize: 12, color: "#666", whiteSpace: "nowrap" }}>Fecha del snapshot:</label>
        <input
          type="date"
          value={fecha}
          onChange={e => setFecha(e.target.value)}
          style={{ fontSize: 13, padding: "6px 10px", borderRadius: 8,
            border: "0.5px solid #ddd", outline: "none", background: "#fafaf9" }}
        />
      </div>

      {/* Selector de archivo */}
      <div
        onClick={() => ref.current?.click()}
        style={{
          border: archivo ? "1px solid #1D9E75" : "0.5px solid #e0e0de",
          borderRadius: 10, padding: "14px 16px",
          background: archivo ? "#f4fbf8" : "#fafaf9",
          cursor: "pointer", marginBottom: "1rem",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 3 }}>
              {archivo ? "✓ " : ""}Stock del proveedor
            </div>
            <div style={{ fontSize: 11, color: "#888" }}>
              {archivo ? archivo.name : "Columnas esperadas: Nombre, Tipo, Precio Proveedor, Precio Sugerido, Stock"}
            </div>
          </div>
          <div style={{
            fontSize: 11, padding: "4px 12px", borderRadius: 20,
            background: archivo ? "#1D9E75" : "transparent",
            color: archivo ? "#fff" : "#888",
            border: archivo ? "none" : "0.5px solid #ddd",
          }}>
            {archivo ? "Cambiar" : "Seleccionar"}
          </div>
        </div>
        <input
          ref={ref}
          type="file"
          accept=".xlsx"
          style={{ display: "none" }}
          onChange={e => setArchivo(e.target.files[0] || null)}
        />
      </div>

      <button
        onClick={handleEnviar}
        disabled={!archivo || estado === "cargando"}
        style={{
          width: "100%", padding: "12px", borderRadius: 10, border: "none",
          background: archivo && estado !== "cargando" ? "#534AB7" : "#e0e0de",
          color: archivo && estado !== "cargando" ? "#fff" : "#aaa",
          fontSize: 14, fontWeight: 500,
          cursor: archivo && estado !== "cargando" ? "pointer" : "default",
        }}
      >
        {estado === "cargando" ? "Cargando..." : "Registrar snapshot de stock"}
      </button>

      {mensaje && (
        <div style={{
          marginTop: "1rem", padding: "12px 16px", borderRadius: 10,
          background: estado === "exito" ? "#EAF3DE" : "#FCEBEB",
          color: estado === "exito" ? "#3B6D11" : "#A32D2D",
          fontSize: 13,
        }}>
          {mensaje}
        </div>
      )}
    </div>
  );
}
